import { get, find } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import EmailSignupModule from 'components/EmailSignupModule';
import * as actions from 'state/actions';
import Log from 'utils/Log';

const SIGNUP_MODULE = 'pageSectionEmailSignupModule';

const PartnershipPageController = class {
  static get windowData() {
    const data = get(window, ['ALLBIRDS', 'partnershipPage']);

    if (!data) {
      Log.error(
        new Error('Controllers:PartnershipPageController.windowData -- missing window data!')
      );
    }

    return data;
  }

  // Temp method to grab the email page section if it exists
  // Eventually we should move the partnerships page out of liquid and as another page template similar to landing page
  // At that point, we can pass all data down into a page component
  static get emailSignupData() {
    return find(get(PartnershipPageController.windowData, 'pageSections'), pageSection => {
      return get(pageSection, '_contentType') === SIGNUP_MODULE;
    });
  }

  static renderEmailSignupModule = async store => {
    const domElement = await document.getElementById('email-sign-up-form-container');
    const emailData = PartnershipPageController.emailSignupData;
    if (emailData && domElement) {
      ReactDOM.render(
        <EmailSignupModule
          onSubmit={(email, acceptsMarketing) =>
            PartnershipPageController.submitSignupRequest(email, acceptsMarketing, store)
          }
          {...emailData}
        />,
        domElement
      );
    }
  };

  static submitSignupRequest = async (email, acceptsMarketing, store) => {
    PartnershipPageController.renderEmailSignupModule(store);

    store.dispatch(
      actions.signUpForNewsletter({
        emailAddress: email,
        origination: 'signupModule',
        acceptsMarketing,
      })
    );
  };

  static init = store => {
    PartnershipPageController.renderEmailSignupModule(store);
  };
};

export default PartnershipPageController;
